'use client';
import React from 'react';
import Script from 'next/script';
import {LetzChatUrl} from './LetzChat.constants';
import {usePathname} from 'next/navigation';
import {
  getCurrentLanguage,
  languageChange,
  updateLocaleInDOM,
} from '@utils/translate.utils';
import {LanguageTypes} from './LetzChat.type';
import logger from '@utils/logger';

export function LetzChat() {
  const pathname = usePathname();

  // const onLoad = (e: any) => {
  // };
  // const onReady = () => {
  // };
  // const onError = (e: any) => {};

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const lang = getCurrentLanguage() as LanguageTypes;
    const langChange = languageChange(lang);
    updateLocaleInDOM(lang);
  }, [pathname]);

  return null;

  // return (
  //   <Script
  //     id='letzchat-script'
  //     src={LetzChatUrl}
  //     onLoad={onLoad}
  //     onReady={onReady}
  //     onError={onError}
  //   />
  // );
}
